(() => {
  const SELECTORS = {
    section: '[data-sude-product-conversion]',
    productSection: '[data-section-type="product"]',
    productForm: 'form[action*="/cart/add"]',
    variantInput: 'input[name="id"]',
    originalAddButton:
      'button[name="add"], button[type="submit"][data-add-to-cart], button[type="submit"]',
  };

  const getVariantId = (root) => {
    const input = root.querySelector(
      `${SELECTORS.productForm} ${SELECTORS.variantInput}`
    );

    return input ? String(input.value) : '';
  };

  const getConfiguration = (root) => {
    const dataElement = root.querySelector(
      '[data-sude-product-variant-data]'
    );

    if (!dataElement) return null;

    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      console.warn('Sude variant verisi okunamadı.', error);
      return null;
    }
  };

  const getCurrentVariant = (root, configuration) => {
    if (!configuration || !configuration.variants) return null;

    const variantId = getVariantId(root);

    return (
      configuration.variants.find(
        (variant) => String(variant.id) === String(variantId)
      ) || configuration.variants[0]
    );
  };

  const updateInventory = (root, variant) => {
    const inventory = root.querySelector('[data-sude-inventory]');

    if (!inventory || !variant) return;

    const text = inventory.querySelector(
      '[data-sude-inventory-text]'
    );

    const threshold = Number(
      inventory.dataset.lowStockThreshold || 5
    );

    inventory.classList.remove('is-low', 'is-sold-out');

    if (!variant.available) {
      inventory.classList.add('is-sold-out');
      text.textContent = 'Bu seçenek şu anda tükendi.';
      return;
    }

    if (!variant.tracked) {
      text.textContent = 'Stokta — sipariş vermeye hazır.';
      return;
    }

    const quantity = Number(variant.inventory_quantity);

    if (quantity <= 0 && variant.available) {
      text.textContent = 'Siparişe açık.';
      return;
    }

    if (quantity <= threshold) {
      inventory.classList.add('is-low');
      text.textContent = `Acele edin, seçili bedende yalnızca ${quantity} adet kaldı.`;
      return;
    }

    text.textContent = `Seçili bedende ${quantity} adet stokta.`;
  };

  const updateFreeShipping = (root, variant, configuration) => {
    const shippingItem = root.querySelector(
      '[data-sude-free-shipping]'
    );

    if (!shippingItem || !variant || !configuration) return;

    const threshold = Number(
      shippingItem.dataset.shippingThreshold || 0
    );

    if (!threshold) {
      shippingItem.hidden = false;
      return;
    }

    shippingItem.hidden = Number(variant.price) < threshold;
  };

  const updateStickyCart = (root, variant) => {
    const stickyCart = root.querySelector('[data-sude-sticky-cart]');

    if (!stickyCart || !variant) return;

    const price = stickyCart.querySelector(
      '[data-sude-sticky-price]'
    );

    const button = stickyCart.querySelector(
      '[data-sude-sticky-button]'
    );

    if (price) {
      price.textContent = variant.formatted_price;
    }

    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available
        ? button.dataset.availableLabel
        : button.dataset.soldOutLabel;
    }
  };

  const updateEverything = (root, configuration) => {
    const variant = getCurrentVariant(root, configuration);

    if (!variant) return;

    updateInventory(root, variant);
    updateFreeShipping(root, variant, configuration);
    updateStickyCart(root, variant);
  };

  const initializeStickyCart = (root) => {
    const stickyCart = root.querySelector('[data-sude-sticky-cart]');

    if (!stickyCart) return;

    const productForm = root.querySelector(SELECTORS.productForm);
    const originalButton = productForm
      ? productForm.querySelector(SELECTORS.originalAddButton)
      : null;

    const stickyButton = stickyCart.querySelector(
      '[data-sude-sticky-button]'
    );

    if (!productForm || !originalButton || !stickyButton) return;

    stickyButton.addEventListener('click', () => {
      if (stickyButton.disabled) return;

      originalButton.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });

      window.setTimeout(() => {
        originalButton.click();
      }, 250);
    });

    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const shouldShow = !entry.isIntersecting;

          stickyCart.classList.toggle('is-visible', shouldShow);
          document.body.classList.toggle(
            'sude-sticky-cart-visible',
            shouldShow
          );
        });
      },
      {
        threshold: 0.15,
      }
    );

    visibilityObserver.observe(originalButton);
  };

  const initializeProduct = (root) => {
    if (root.dataset.sudeInitialized === 'true') return;

    root.dataset.sudeInitialized = 'true';

    const configuration = getConfiguration(root);

    updateEverything(root, configuration);
    initializeStickyCart(root);

    root.addEventListener('change', () => {
      window.setTimeout(() => {
        updateEverything(root, configuration);
      }, 60);
    });

    document.addEventListener('variant:change', (event) => {
      const productSection = event.target.closest(
        SELECTORS.productSection
      );

      if (productSection && root.contains(productSection)) {
        window.setTimeout(() => {
          updateEverything(root, configuration);
        }, 30);
      }
    });

    const variantInput = root.querySelector(
      `${SELECTORS.productForm} ${SELECTORS.variantInput}`
    );

    if (variantInput) {
      const inputObserver = new MutationObserver(() => {
        updateEverything(root, configuration);
      });

      inputObserver.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value'],
      });
    }
  };

  const initializeAll = () => {
    document
      .querySelectorAll(SELECTORS.section)
      .forEach(initializeProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();